import { cva, type VariantProps } from 'class-variance-authority';

/**
 * HEN SectionHeader variants using HEN Design System tokens.
 * All styling references design tokens defined in tailwind.config.ts.
 */
export const sectionHeaderVariants = cva(['flex flex-col'], {
  variants: {
    align: {
      left: ['items-start', 'text-left'],
      center: ['w-full', 'items-center', 'text-center'],
    },
    'align-md': {
      left: ['md:items-start', 'md:text-left'],
      center: ['md:items-center', 'md:text-center'],
    },
  },
  defaultVariants: {
    align: 'left',
  },
});

export type SectionHeaderVariantProps = VariantProps<
  typeof sectionHeaderVariants
>;
